var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningOrangeTriangle(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05609 1.35801C6.62516 0.501757 5.40276 0.501759 4.97183 1.35801L0.837968 9.57189C0.447479 10.3478 1.01148 11.263 1.8801 11.263H10.1478C11.0164 11.263 11.5804 10.3478 11.19 9.57188L7.05609 1.35801ZM6.02247 7.25757C5.78085 7.25757 5.58497 7.0617 5.58497 6.82007V5.07007C5.58497 4.82845 5.78085 4.63257 6.02247 4.63257C6.2641 4.63257 6.45997 4.82845 6.45997 5.07007V6.82007C6.45997 7.0617 6.2641 7.25757 6.02247 7.25757ZM6.02403 7.84091C6.31312 7.84091 6.54747 8.07596 6.54747 8.36591C6.54747 8.65586 6.31312 8.89091 6.02403 8.89091H6.0209C5.73182 8.89091 5.49747 8.65586 5.49747 8.36591C5.49747 8.07596 5.73182 7.84091 6.0209 7.84091H6.02403Z",
    fill: "#F79009"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOrangeTriangle);
export default __webpack_public_path__ + "static/media/warning-orange-triangle.574a98f8dbcd79fb9aab8c866ebc2663.svg";
export { ForwardRef as ReactComponent };